"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _formik = require("formik");

var _attributeOptions = _interopRequireDefault(require("../attributeOptions"));

require("./index.css");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AttributeSubSection = function AttributeSubSection(_ref) {
  var attribute = _ref.attribute,
      attributeId = _ref.attributeId,
      parentId = _ref.parentId,
      value = _ref.value,
      onChange = _ref.onChange,
      setFieldValue = _ref.setFieldValue;
  var options = attribute.options,
      type = attribute.type,
      name = attribute.name,
      sortOptions = attribute.sortOptions;

  var _useField = (0, _formik.useField)("attributes.".concat(parentId)),
      _useField2 = _slicedToArray(_useField, 1),
      field = _useField2[0];

  var onSelectAll = function onSelectAll() {
    setFieldValue("attributes.".concat(attributeId), _objectSpread(_objectSpread({}, value), {}, {
      choice: Object.keys(options)
    }));
    var choice = Object.keys(options);

    if (field.value && field.value.choice) {
      choice = choice.concat(field.value.choice);
    }

    setFieldValue("attributes.".concat(parentId), _objectSpread(_objectSpread({}, value), {}, {
      choice: choice
    }));
  };

  var onUnselectAll = function onUnselectAll() {
    setFieldValue("attributes.".concat(attributeId), _objectSpread(_objectSpread({}, value), {}, {
      choice: []
    })); // Remove from parent attribute too

    if (field.value && field.value.choice) {
      var choice = _toConsumableArray(field.value.choice); // Remove each of these options from the parent choice array


      Object.keys(options).forEach(function (key) {
        var index = choice.indexOf(key);

        if (index > -1) {
          choice.splice(index, 1);
        }
      });
      setFieldValue("attributes.".concat(parentId), _objectSpread(_objectSpread({}, value), {}, {
        choice: choice
      }));
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-section-subheader flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex center font-lato text-lightBlue "
  }, name), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginLeft20 marginRight20"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "primary",
    onClick: onSelectAll
  }, "Select All")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "primary",
    onClick: onUnselectAll
  }, "Unselect All"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-attribute-options-container"
  }, /*#__PURE__*/_react.default.createElement(_attributeOptions.default, {
    attributeName: name,
    parent: field.value,
    value: value,
    onChange: onChange,
    attributeId: attributeId,
    parentId: parentId,
    type: type,
    options: options,
    sortOptions: sortOptions,
    setFieldValue: setFieldValue
  })));
};

var _default = AttributeSubSection;
exports.default = _default;